import React from "react";
import TopHeader from "../../Components/TopHeader";
import MainHeader from "../../Components/MainHeader";
import FAQ from "../../Components/FAQ";
import Footer from "../../Components/Footer";
import Newsletter from "../../Components/Newsletter";

function FAQPage(){
    return(
        <>
        <TopHeader/>
        <MainHeader/>
        <FAQ/>
        <Newsletter/>
        <Footer/>
        </>
    );
}
export default FAQPage;
